(function () {
class $27fffe3fa7b6b007$var$lsgPdpBundleWidget extends HTMLElement {
    constructor(){
        super();
        this.selections = {};
        this.productForm;
        this.productPrice;
        this.productCompare;
        this.productPercent;
        this.blockColorPicker = document.querySelector('lsg-variant-selects') ? true : false;
    }
    connectedCallback() {
        this.addEventListener('click', (e)=>{
            const opt = e.target.closest('.js-option-select');
            if (opt && this.contains(opt)) {
                this.onOptionClick(opt);
                return;
            }
            const prod = e.target.closest('.js-product-select');
            if (prod && this.contains(prod)) this.onProductClick(prod);
        });
        this.handleVariantInitialState();
        this.productForm = document.querySelector('lsg-product-form');
        this.productPrice = document.querySelector('.c-price__retail');
        this.productCompare = document.querySelector('.c-price__list');
        this.productPercent = document.querySelector('.c-price__percent');
        this.stickyTitle = document.querySelector('.b-pdp-sticky-cta__title');
        this.stickyPrice = document.querySelector('.b-pdp-sticky__price');
        this.stickyBtn = document.querySelector('.b-pdp-sticky-cta .trigger-add-to-cart');
        this.stickyPercent = document.querySelector('.b-pdp-sticky__percentage-off');
        this.stickyCompare = document.querySelector('.b-pdp-sticky__compare-price');
    }
    handleVariantInitialState() {
        const checkedInput = document.querySelector('.lsg-swatch-input__input:checked');
        if (checkedInput) this.querySelectorAll(`.js-option-select[data-option-value="${checkedInput.value}"]`).forEach((option)=>{
            this.onOptionClick(option);
        });
    }
    onProductClick(activeEl) {
        this.querySelectorAll('.js-product-select').forEach((p)=>p.classList.toggle('active', p === activeEl));
        if (!this.blockColorPicker) this.querySelectorAll('.option-select').forEach((o)=>o.classList.toggle('hidden', o.dataset.productId !== activeEl.dataset.productId));
        document.querySelector('lsg-product-form').querySelector('input[name="id"]').value = activeEl.dataset.variantId;
        this.querySelector('.js-product-select-title').textContent = activeEl.dataset.title;
        this.updateGlobalIfActive(activeEl.dataset.productId, activeEl.dataset.variantId);
        const pricing = this.getVariantPricing(activeEl.dataset.productId, activeEl.dataset.variantId);
        let activeVariantId = activeEl.dataset.variantId;
        if (activeEl.classList.contains('js-product-select-default')) {
            const color = document.querySelector('.lsg-swatch-input__input:checked').value;
            activeVariantId = window.productVariants.find((v)=>v.option1 === color)?.id;
        }
        this.updateSticky(activeEl.dataset.title, pricing, activeVariantId, activeEl.dataset.variantId, 'onProductClick');
    }
    onOptionClick(optEl) {
        const productId = optEl.dataset.productId;
        const pos = String(optEl.dataset.optionPosition);
        const val = (optEl.dataset.optionValue || '').trim();
        const variantId = optEl.dataset.variantId;
        const productSelectActive = this.querySelector('.js-product-select.active');
        const productSelects = this.querySelectorAll('.js-product-select');
        const parentProductSelect = this.querySelector('.js-product-select[data-product-id="' + productId + '"]');
        const optionWrap = this.querySelector(`.option-select[data-product-id="${productId}"]`);
        optEl.classList.add('active');
        optEl.closest('.js-options-wrap').querySelectorAll('.js-option-select').forEach((n)=>n.classList.toggle('active', n === optEl));
        productSelects.forEach((p)=>{
            if (!this.querySelector(`.js-options-wrap[data-product-id="${p.dataset.productId}"]`)) return;
            const optionWraps = Array.from(this.querySelectorAll(`.js-options-wrap[data-product-id="${p.dataset.productId}"]`));
            const option1 = optionWraps.find((o)=>o.dataset.optionPosition === '1')?.querySelector('.js-option-select.active')?.dataset.optionValue;
            const option2 = optionWraps.find((o)=>o.dataset.optionPosition === '2')?.querySelector('.js-option-select.active')?.dataset.optionValue;
            const option3 = optionWraps.find((o)=>o.dataset.optionPosition === '3')?.querySelector('.js-option-select.active')?.dataset.optionValue;
            const match = window.bundleVariants[p.dataset.productId].find((v)=>(!option1 || v.option1 === option1) && (!option2 || v.option2 === option2) && (!option3 || v.option3 === option3));
            const variantId = match ? match.id : null;
            p.dataset.variantId = variantId;
            p.querySelector('input').value = variantId;
        });
        if (parentProductSelect.classList.contains('active')) {
            const pricing = this.getVariantPricing(productId, variantId);
            if (pricing) this.updatePriceUI(productId, pricing);
            this.updateGlobalIfActive(productId, variantId);
            this.updateSticky(productSelectActive.dataset.title, pricing, productSelectActive.dataset.variantId, productSelectActive.dataset.variantId, 'onOptionClick');
        }
        if (!this.selections[productId]) this.selections[productId] = {};
        this.selections[productId][pos] = val;
        const wrap = this.querySelector(`.option-select[data-product-id="${productId}"][data-option-position="${pos}"]`);
        if (wrap) wrap.querySelectorAll('.js-option-select').forEach((n)=>n.classList.toggle('active', n === optEl));
        this.updateImagesForProduct(productId);
        if (productSelectActive && productSelectActive.dataset.productId === productId && this.productForm) {
            const idInput = this.productForm.querySelector('input[name="id"]');
            if (idInput && variantId) idInput.value = String(productSelectActive.dataset.variantId);
        }
        this.querySelector(`.js-option-select-title[data-product-id="${productId}"][data-option-position="${pos}"]`).textContent = val;
    }
    updateImagesForProduct(productId) {
        const productBlock = this.querySelector(`.js-product-select[data-product-id="${productId}"]`);
        if (!productBlock) return;
        const imgs = productBlock.querySelectorAll('img.bundle-variant-image[data-group]');
        if (!imgs.length) return;
        const groups = new Map();
        imgs.forEach((img)=>{
            const g = img.dataset.group;
            if (!groups.has(g)) groups.set(g, {
                all: [],
                def: null
            });
            const bucket = groups.get(g);
            bucket.all.push(img);
            if (img.dataset.default === 'true' || img.hasAttribute('data-default')) bucket.def = img;
        });
        const sel = this.selections[productId] || {};
        groups.forEach(({ all: all, def: def })=>{
            const match = this.findBestMatch(all, sel);
            all.forEach((img)=>img.classList.add('hidden'));
            (match || def || all[0])?.classList.remove('hidden');
        });
    }
    findBestMatch(images, selections) {
        let best = null, bestScore = -1;
        images.forEach((img)=>{
            const o1 = (img.dataset.opt1 || '').toLowerCase().trim();
            const o2 = (img.dataset.opt2 || '').toLowerCase().trim();
            const o3 = (img.dataset.opt3 || '').toLowerCase().trim();
            let score = 0, ok = true;
            if (selections['1']) {
                const s1 = selections['1'].toLowerCase().trim();
                if (o1) {
                    if (o1 === s1) score++;
                    else ok = false;
                }
            }
            if (ok && selections['2']) {
                const s2 = selections['2'].toLowerCase().trim();
                if (o2) {
                    if (o2 === s2) score++;
                    else ok = false;
                }
            }
            if (ok && selections['3']) {
                const s3 = selections['3'].toLowerCase().trim();
                if (o3) {
                    if (o3 === s3) score++;
                    else ok = false;
                }
            }
            if (ok && score > bestScore) {
                bestScore = score;
                best = img;
            }
        });
        return best;
    }
    formatMoney(cents) {
        if (cents == null) return '';
        if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
        return (Number(cents) / 100).toFixed(2);
    }
    getVariantPricing(productId, variantId) {
        const block = this.querySelector(`.js-product-select[data-product-id="${productId}"]`);
        if (!block) return null;
        const node = block.querySelector(`script.bundle-variants-pricing[data-product-id="${productId}"]`);
        if (!node) return null;
        let arr = [];
        try {
            arr = JSON.parse(node.textContent || '[]');
        } catch (e) {
            arr = [];
        }
        return arr.find((v)=>String(v.id) === String(variantId)) || null;
    }
    updatePriceUI(productId, pricing) {
        const priceEl = this.querySelector(`.js-price[data-product-id="${productId}"]`);
        const compareEl = this.querySelector(`.js-compare[data-product-id="${productId}"]`);
        const percentEl = this.querySelector(`.js-percent[data-product-id="${productId}"]`);
        if (!priceEl) return;
        priceEl.textContent = this.formatMoney(pricing?.price ?? null);
        const cmp = pricing?.compare_at_price;
        if (cmp && cmp > (pricing?.price || 0)) {
            const diff = cmp - pricing.price;
            const pct = Math.floor(diff * 100 / cmp);
            if (compareEl) {
                compareEl.classList.remove('hidden');
                compareEl.innerHTML = `<del>${this.formatMoney(cmp)}</del>`;
            }
            if (percentEl) {
                percentEl.classList.remove('hidden');
                percentEl.textContent = `${pct}% off`;
            }
        } else {
            compareEl?.classList.add('hidden');
            percentEl?.classList.add('hidden');
        }
    }
    updateGlobalPriceUI(pricing) {
        if (!this.productPrice) return;
        const fmt = (c)=>this.formatMoney(c ?? null);
        this.productPrice.textContent = fmt(pricing?.price);
        const cmp = pricing?.compare_at_price;
        const hasDisc = cmp && cmp > (pricing?.price || 0);
        if (this.productCompare) {
            if (hasDisc) {
                this.productCompare.classList.remove('hidden');
                this.productCompare.innerHTML = `<del>${fmt(cmp)}</del>`;
            } else {
                this.productCompare.classList.add('hidden');
                this.productCompare.innerHTML = '';
            }
        }
        if (this.productPercent) {
            if (hasDisc) {
                const diff = cmp - pricing.price;
                const pct = Math.floor(diff * 100 / cmp);
                this.productPercent.classList.remove('hidden');
                this.productPercent.textContent = `${pct}% off`;
            } else {
                this.productPercent.classList.add('hidden');
                this.productPercent.textContent = '';
            }
        }
    }
    updateGlobalIfActive(productId, variantId) {
        const active = this.querySelector('.js-product-select.active');
        if (!active || active.dataset.productId !== String(productId)) return;
        const pricing = this.getVariantPricing(productId, variantId);
        if (pricing) this.updateGlobalPriceUI(pricing);
    }
    updateSticky(title, pricing, variantId, productId, initiator = false) {
        if (this.stickyTitle) this.stickyTitle.textContent = title || '';
        if (this.stickyPrice && pricing) this.stickyPrice.textContent = this.formatMoney(pricing.price);
        if (this.stickyCompare && pricing) this.stickyCompare.textContent = this.formatMoney(pricing.compare_at_price);
        if (this.stickyPercent && pricing) {
            const diff = pricing.compare_at_price - pricing.price;
            const pct = Math.floor(diff * 100 / pricing.compare_at_price);
            this.stickyPercent.textContent = `${pct}% off`;
        }
        if (this.stickyBtn) {
            this.stickyBtn.dataset.productId = variantId;
            this.stickyBtn.dataset.variantId = variantId;
        }
    }
}
customElements.define('lsg-pdp-bundle-widget', $27fffe3fa7b6b007$var$lsgPdpBundleWidget);

})();
